import { createContext } from 'react';
import { tPipeContext } from './Pipe.types';
import { initialState } from './Pipe.constants';

export const PipeContext = createContext<tPipeContext>(initialState);
